"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _EditableContext = _interopRequireDefault(require("./EditableContext"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const EditableCell = props => {
  const inputRef = _react.default.useRef(null);

  const form = (0, _react.useContext)(_EditableContext.default);
  const [editing, setEditing] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    const {
      dataIndex,
      record
    } = props;
    setEditing(!editing);

    if (form) {
      form.setFieldsValue({
        [dataIndex]: record[dataIndex]
      });
    }
  };

  const save = async () => {
    try {
      if (form) {
        const values = await form.validateFields();
        props.handleSaveCell({ ...props.record,
          ...values
        });
      }
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  const {
    children,
    editable,
    dataIndex,
    title,
    record,
    required,
    validator,
    editRender,
    handleSaveCell,
    ...restProps
  } = props;
  let childNode = children;

  if (editable) {
    const rules = [];

    if (required) {
      rules.push({
        required,
        message: `${title} is required.`
      });
    }

    if (validator) {
      rules.push(() => ({
        validator(_, value) {
          if (!value || record[dataIndex] === value) {
            return Promise.resolve();
          }

          return validator(_, value);
        },

        validateTrigger: ['onChange', 'onBlur']
      }));
    }

    childNode = editing ? editRender ? editRender(record, inputRef, rules, save) : /*#__PURE__*/_react.default.createElement(_form.default.Item, {
      style: {
        margin: 0
      },
      name: dataIndex,
      rules: rules,
      initialValue: record[dataIndex]
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      className: "editable-cell-input",
      ref: inputRef,
      onPressEnter: save,
      onBlur: save
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: "editable-cell-value-wrap",
      onClick: toggleEdit
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement("td", Object.assign({}, restProps), childNode);
};

var _default = EditableCell;
exports.default = _default;